import React, { FC } from 'react'
import { classNames } from '@dt/fe-utils'
import './index.scss'

// interface
interface IProps {
  className?: string;
  style?: Record<string, any>;
  /** 是否有动画 */
  animated?: boolean;
}

/** skeleton的基础组件 */
const SkeletonText: FC<IProps> = ({ className, style, animated = true }) => {
  return (
    <div
      className={classNames('skeleton-text', className, {
        'skeleton-text-animated': animated
      })}
      style={style}
    >
    </div>
  )
}

export default SkeletonText
